import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class fromPriceBehaviour extends AbstractDataAttributeBehaviour {

    attrSelectors = {
        priceValue: 'data-from-price',
        display: 'data-from-price-display'
    };

    getContainerSelector()
    {
        return '[' + this.attrSelectors.priceValue + ']';
    }

    initContainer(container)
    {
        let value = container.getAttribute(this.attrSelectors.priceValue);
        let displayElements = document.querySelectorAll('[' + this.attrSelectors.display + ']');

        for (let i=0; i< displayElements.length; i++) {
            displayElements[i].innerText = value;
        }

    }
}